// app/frontend/components/ui/Badges/GradientBadge.tsx
import React from 'react';
import { Badge } from '@mantine/core';
import { themeAlpha, whiteTextGradient } from '../../../src/utils/pageTheme';

interface GradientBadgeProps {
  children: React.ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
}

const GradientBadge: React.FC<GradientBadgeProps> = ({
  children,
  size = 'md',
  className,
  style,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <Badge
      size={size}
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        // The site's orange diagonal, or the event theme's white-text fill on
        // a themed page, so the badge follows the accent there (#2358).
        background: whiteTextGradient(),
        boxShadow: `0 2px 4px ${themeAlpha(0.3)}`,
        border: 'none',
        borderRadius: '8px',
        color: 'white',
        textTransform: 'capitalize',
        padding: size === 'xs' ? '4px 10px' : size === 'sm' ? '6px 12px' : size === 'md' ? '8px 14px' : size === 'lg' ? '10px 16px' : '12px 18px',
        fontSize: size === 'xs' ? '0.75rem' : size === 'sm' ? '0.875rem' : size === 'md' ? '0.9375rem' : size === 'lg' ? '1rem' : '1.125rem',
        ...style,
      }}
    >
      {children}
    </Badge>
  );
};

export default GradientBadge;

